export default class Menu {
  constructor() {
    //console.log('Menu');
  }
}
